<template>
  <div class="slider-inner slider-a">
    <Logo />

    <img class="a1 animated fadeIn" src="~images/a/a_1.png" />
    <img class="a2 animated fadeInDown" src="~images/a/a_2.png" />
    <img class="a3 animated zoomIn" src="~images/a/a_3.png" />
    <img class="a4 animated fadeInLeft" src="~images/a/a_4.png" />
    <img class="a5 animated fadeInRight" src="~images/a/a_5.png" />
    <img class="a6" src="~images/a/a_6.png" />

    <Tip />
  </div>
</template>

<script>
export default {
  name: "SliderA",
};
</script>

<style lang="less" scoped>
.slider-a {
  background: url("~images/a/bg.jpg") center top / 100% no-repeat;
  .a1 {
    position: absolute;
    top: 20%;
    left: 0;
    width: 100%;
  }
  .a2 {
    position: absolute;
    top: 16%;
    left: 0;
    width: 100%;
    animation-delay: 1s;
  }
  .a3 {
    position: absolute;
    top: 28%;
    left: 0;
    width: 100%;
    animation-delay: 2s;
  }
  .a4 {
    position: absolute;
    left: 0;
    bottom: 1rem;
    width: 3.77rem;
    animation-delay: 2.5s;
  }
  .a5 {
    position: absolute;
    right: 0;
    bottom: 1.6rem;
    width: 3.85rem;
    animation-delay: 2.2s;
  }
  .a6 {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>